module.exports = __webpack_public_path__ + "static/sport/img-left.81b2fa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-left.png
// module id = mzg9
// module chunks = 0